import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ChecklistStep, ChecklistStepRoute } from './model/checklist-steps';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { MyTestSessionsSetupService, ITestSessionSetupInfo } from '../my-test-sessions-setup.service';
import { Subscription } from 'rxjs';
import { LangService } from '../../core/lang.service';
import { LoginGuardService } from '../../api/login-guard.service';

interface IChecklistState {
  isComplete: boolean,
  steps: IChecklistStep[],
}
interface IChecklistStep {
  id: ChecklistStep,
  caption: string,
  routeSuffix: string,
  isComplete?: boolean,
}
@Component({
  selector: 'pnel-cts-checklist',
  templateUrl: './pnel-cts-checklist.component.html',
  styleUrls: ['./pnel-cts-checklist.component.scss']
})
export class PnelCtsChecklistComponent implements OnInit, OnDestroy {

  @Input() setupId:string; // this is no longer required, it is using the main service for the current setup 
  @Input() currentStepId:ChecklistStep; 
  @Input() isReleased:boolean; 

  checklistState:IChecklistState = {
    isComplete: false,
    steps: [
      {id: ChecklistStep.TestWindow,            routeSuffix:ChecklistStepRoute.TestWindow,            caption: 'Test Window', isComplete:false,},
      {id: ChecklistStep.Location,              routeSuffix:ChecklistStepRoute.Location,              caption: 'Location'},
      {id: ChecklistStep.TechnicalReadiness,    routeSuffix:ChecklistStepRoute.TechnicalReadiness,    caption: 'Technical Readiness'},
      {id: ChecklistStep.DateAndTime,           routeSuffix:ChecklistStepRoute.DateAndTime,           caption: 'Date & Time'},
      {id: ChecklistStep.Accommodations,        routeSuffix:ChecklistStepRoute.Accommodations,        caption: 'Accommodations', isComplete:false,},
      {id: ChecklistStep.RestrictedSessions,    routeSuffix:ChecklistStepRoute.RestrictedSessions,    caption: 'Restricted Sessions'},
      {id: ChecklistStep.MakeSessionsAvailable, routeSuffix:ChecklistStepRoute.MakeSessionsAvailable, caption: 'Make Sessions Available'},
      {id: ChecklistStep.SendInvitations,       routeSuffix:ChecklistStepRoute.SendInvitations,       caption: 'Send Invitations'},
    ]
  }

  private mySetupSub:Subscription;

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private mySetup: MyTestSessionsSetupService,
    private lang:LangService,
    private loginGuard:LoginGuardService,
  ) { }

  ngOnInit() {
    this.mySetupSub = this.mySetup.sub().subscribe(d => this.updateChecklistState(d) )
  }

  ngOnDestroy() {
    if (this.mySetupSub){ this.mySetupSub.unsubscribe(); }
  }

  updateChecklistState(testSessionSetup:ITestSessionSetupInfo){
    if (testSessionSetup){
      this.checklistState.steps.forEach(step => {
        switch(step.id){
          case ChecklistStep.TestWindow:            step.isComplete = !!testSessionSetup.checkTestWindow    ; break;
          case ChecklistStep.Location:              step.isComplete = !!testSessionSetup.checkLocation      ; break;
          case ChecklistStep.TechnicalReadiness:    step.isComplete = !!testSessionSetup.checkTechReady     ; break;
          case ChecklistStep.DateAndTime:           step.isComplete = !!testSessionSetup.checkDateTime      ; break;
          case ChecklistStep.Accommodations:        step.isComplete = !!testSessionSetup.checkAccom         ; break;
          case ChecklistStep.RestrictedSessions:    step.isComplete = !!testSessionSetup.checkRestricted    ; break;
          case ChecklistStep.MakeSessionsAvailable: step.isComplete = !!testSessionSetup.isAvailable        ; break;
          case ChecklistStep.SendInvitations:       step.isComplete = !!testSessionSetup.checkSendInvites   ; break;
        }
      })
    }
  }

  cancelSetup(){
    const msg = this.lang.tra('cts_checklist_cancel_btn')
    this.loginGuard.confirmationReqActivate(msg, () => {
      this.mySetup
        .cancel()
        .then( () => {
          this.router.navigate([
            this.breadcrumbsService.TESTADMIN_DASHBOARD().route
          ])
        })
    })
  }

  isStepCurrent(step:IChecklistStep){
    return (step.id === this.currentStepId);
  }

  isStepChecked(step:IChecklistStep){
    return step.isComplete;
  }

  gotoStep(step:IChecklistStep){
    // console.log('istouched', this.mySetup.isTouched());
    // TO DO: make sure to save the last action...
    let breadcrumb = this.breadcrumbsService.TESTADMIN_CREATE_TEST_SESSION(this.setupId, step.routeSuffix);
    this.router.navigate([ breadcrumb.route ]);
    this.mySetup.markCurrentStepAsUnTouched();
  }

}
